export const BATCH_NAME_MAX_LENGTH = 30;

export const truncateBatchName = (name: string) =>
  name.length > BATCH_NAME_MAX_LENGTH
    ? name.slice(0, BATCH_NAME_MAX_LENGTH).trimEnd() + "…"
    : name;
